import { forwardRef } from 'react';
import { getBlockId } from '../../utils/getBlockId';

const TimeCell = ({ block, time, column }) => {
  const fill = column.fill ? column.fill(block, time) : undefined;

  return (
    <td className={column.className}>
      {fill != null &&
        <div className={column.fillClass} style={{ height: `${fill * 100}%` }} />
      }
      {column.render(time.time)}
    </td>
  );
};

const SchedulerBlock = forwardRef(({ block, columns, compact, ...props }, ref) => {
  // TODO: Maybe remove this. This was used in Userflow to identify what was in a block, but we
  //       currently aren't using it. [twl 4.Oct.22]
  const state = columns.intent.state ? columns.intent.state(block) : undefined;
  const times = block.times;
  const startTime = times[0];

  // Test-only hooks (no styling/behavior impact) so Cypress can target & assert blocks by
  // their rendered identity, start time, title and conflict status without relying on
  // generated class names or DOM position. [test hook]
  const testProps = {
    'data-test-block-id': getBlockId(block),
    'data-test-block-start': startTime?.time?.toString(),
    'data-test-block-title': block.intent?.todo?.title,
    'data-test-block-type': block.intent?.todo?.type,
    'data-test-block-conflict': block.conflictDuration > 0 ? block.conflictType : undefined,
  };

  // A block whose entire duration conflicts past the schedule end has no time slots to
  // render (see the `scheduleEnd` clamping in the layout engine)
  if (!startTime) {
    return <tbody {...props} {...testProps} ref={ref} />;
  }

  return (
    <tbody {...props} {...testProps} ref={ref}>
      <tr key={startTime.time}>
        <TimeCell block={block} column={columns.time} time={startTime} />
        <td className={columns.intent.className} rowSpan={times.length} data-has={state}>
          {columns.intent.render(block)}
        </td>
      </tr>

      {!compact && times.length > 1 &&
        times.slice(1).map(time => (
          <tr key={time.time}>
            <TimeCell block={block} column={columns.time} time={time} />
          </tr>
        ))
      }
    </tbody>
  );
});

export default SchedulerBlock;
